import { Link } from 'components'
import { AllAlgoChallenges, AllFrontendChallenges } from 'features/AlgoEditor'
import { AllBackendChallengesDetails } from 'features/Backend'
import React from 'react'

import {
  ArrowRightIcon,
  CheckCircledIcon,
  SymbolIcon
} from '@radix-ui/react-icons'
import { tx } from '@twind/core'

import { modifiedDifficultyofChallenge } from '../../../utils'
import { SQLChallengesDetails } from '../../SQLBrowser'

const QuestionRow = ({
  challenge,
  index,
  questionURL
}: {
  challenge:
    | AllAlgoChallenges
    | AllFrontendChallenges
    | AllBackendChallengesDetails
    | SQLChallengesDetails
  index: number
  questionURL: string
}) => {
  const modifiedDifficulty = modifiedDifficultyofChallenge(challenge.difficulty)

  return (
    <tr className="text-zinc-300 border-b-1 border-zinc-600 hover:bg-white hover:bg-opacity-5 transition-colors">
      <td className="text-center">{index + 1}</td>
      <td className="flex">
        <Link
          href={questionURL}
          className="capitalize truncate cursor-pointer hover:underline w-full">
          {challenge.name}
        </Link>
      </td>
      {challenge.topic && (
        <td className="capitalize text-pink-100">{challenge.topic}</td>
      )}
      <td className="capitalize text-pink-100">{challenge.score}</td>
      <td
        className={tx(
          'capitalize',
          modifiedDifficulty === 'easy'
            ? 'text-green-500'
            : modifiedDifficulty === 'medium'
            ? 'text-yellow-500'
            : modifiedDifficulty === 'hard'
            ? 'text-red-500'
            : 'text-blue-500'
        )}>
        {modifiedDifficulty || '-'}
      </td>
      <td className="flex justify-center">
        {challenge.submission_status === 'solved' ? (
          <CheckCircledIcon className="text-green-500" />
        ) : challenge.submission_status === 'attempted' ? (
          <SymbolIcon className="text-yellow-500" />
        ) : (
          <ArrowRightIcon />
        )}
      </td>
    </tr>
  )
}

export default QuestionRow
